export const CreateAccountError = {
  INLINE: 'inline',
  RECAPTCHA_TOKEN: 'recaptcha token',
  RECAPTCHA_LOW_SCORE: 'recaptcha low score',
  UNAUTHORIZED: 'unauthorized',
} as const
export type CreateAccountErrorType = (typeof CreateAccountError)[keyof typeof CreateAccountError]
